















import {Vue, Prop, Component, Watch} from 'vue-property-decorator';
import AttachmentRowMobile from './AttachmentRowMobile/AttachmentRowMobile.vue';
@Component({
    components: {AttachmentRowMobile}

})
export default class AttachmentEditorMobile extends Vue{
    files: File[] = [];
    onFileChanged(e: any){
        this.files.push(e.target.files[0]);
    }
    onAttachmentRemoved(index: number){
         this.files.splice(index,1);
    }
}
